function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import defaultPropTypes from '../../utils/prop-types';
import { renderComponents } from '../../utils/convenience';
import ListItem from './list-items/list-item';
import FilterList from '../filter-list';
import LocationDetail from '../location-detail';
import Location from '../../utils/model';
import LocationSortingManager from '../../utils/LocationSortingManager';
var DISABLED_CLASS_NAME = 'disabled';
var INITIAL_PAGER_STATE = {
  currentPage: 0
};

var ListPager = function ListPager(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "pager"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pager-status"
  }, "Showing results", /*#__PURE__*/React.createElement("span", {
    className: "page-start"
  }, props.currentStart), "-", /*#__PURE__*/React.createElement("span", {
    className: "page-end"
  }, props.currentEnd), "(out of ", /*#__PURE__*/React.createElement("span", {
    className: "page-total"
  }, props.totalRecords), ")"), /*#__PURE__*/React.createElement("div", {
    className: "pager-buttons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "pager-prev ".concat(props.disablePrev),
    onClick: function onClick(e) {
      props.previousPageClick(props.currentPage, e);
    },
    disabled: props.disablePrev === DISABLED_CLASS_NAME
  }), /*#__PURE__*/React.createElement("button", {
    className: "pager-next ".concat(props.disableNext),
    onClick: function onClick(e) {
      props.nextPageClick(props.currentPage, e);
    },
    disabled: props.disableNext === DISABLED_CLASS_NAME
  })));
};

var ListPaginated = /*#__PURE__*/function (_React$Component) {
  _inherits(ListPaginated, _React$Component);

  var _super = _createSuper(ListPaginated);

  function ListPaginated(props) {
    var _this;

    _classCallCheck(this, ListPaginated);

    _this = _super.call(this, props);
    _this.handlePreviousPageClick = _this.handlePreviousPageClick.bind(_assertThisInitialized(_this));
    _this.handleNextPageClick = _this.handleNextPageClick.bind(_assertThisInitialized(_this));
    _this.handleSelectLocationClick = _this.handleSelectLocationClick.bind(_assertThisInitialized(_this));
    _this.state = INITIAL_PAGER_STATE;
    _this.state.locationsStateHash = _this.props.locationsStateHash;
    _this.selectedLocation = new Location();
    _this.isLocallySelected = false;
    return _this;
  }

  _createClass(ListPaginated, [{
    key: "setPagerState",
    value: function setPagerState(currentPage) {
      this.setState({
        currentPage: currentPage
      });
    }
  }, {
    key: "calculatePageState",
    value: function calculatePageState(currentPage) {
      var maxPages = Math.ceil(this.props.locations.length / this.props.settings.ListCount) - 1; // Page numbers start at 0

      var currentStartRecord = this.props.locations.length > 0 ? currentPage * this.props.settings.ListCount + 1 : 0;
      var currentEndRecord = Math.min((currentPage + 1) * this.props.settings.ListCount, this.props.locations.length);
      var disablePrevButton = currentPage === 0 ? DISABLED_CLASS_NAME : '';
      var disableNextButton = currentPage >= maxPages ? DISABLED_CLASS_NAME : '';
      return {
        currentStartRecord: currentStartRecord,
        currentEndRecord: currentEndRecord,
        disablePrevButton: disablePrevButton,
        disableNextButton: disableNextButton
      };
    }
  }, {
    key: "scrollSelectedIntoView",
    value: function scrollSelectedIntoView() {
      var selectedItem = document.querySelector('.locations-list > .content .selected');
      var parentElement = document.querySelector('.locations-list > .content');
      var scrollToTop = selectedItem.offsetTop + selectedItem.offsetHeight - parentElement.offsetHeight;
      parentElement.scrollTo({
        top: scrollToTop,
        left: 0
      });
    }
  }, {
    key: "handlePreviousPageClick",
    value: function handlePreviousPageClick(page, e) {
      if (page > 0) {
        var currentPage = page - 1;
        this.setPagerState(currentPage);
      }

      e.preventDefault();
    }
  }, {
    key: "handleNextPageClick",
    value: function handleNextPageClick(page, e) {
      var numOfPages = Math.ceil(this.props.locations.length / this.props.settings.ListCount);

      if (page <= numOfPages) {
        var currentPage = page + 1;
        this.setPagerState(currentPage);
      }

      e.preventDefault();
    }
  }, {
    key: "handleSelectLocationClick",
    value: function handleSelectLocationClick(location) {
      this.isLocallySelected = true;
      this.props.onSelectLocation(location);
      window.DGS.Event.getInstance().trigger('trackLocationsHighlightFromList', location.Name, location.PostalCode);
    }
  }, {
    key: "handlePhoneClick",
    value: function handlePhoneClick(location) {
      window.DGS.Event.getInstance().trigger('trackLocationsPhoneNumberList', location.Name, location.PostalCode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var ItemView = this.props.listItemView;
      var DetailView = this.props.listDetailView;
      var startLocationIndex = this.props.settings.ListCount * this.state.currentPage;
      var truncatedLocations = this.props.locations.slice(startLocationIndex, this.props.settings.ListCount + startLocationIndex);

      if (!this.selectedLocation.equals(this.props.selectedLocation) && !this.props.selectedLocation.isDefault()) {
        this.selectedLocation = this.props.selectedLocation;
        this.isNewlySelected = true;
        var selectedLocationIndex = -1;
        this.props.locations.forEach(function (location, index) {
          if (location.equals(_this2.props.selectedLocation)) {
            selectedLocationIndex = index;
          }
        });

        if (selectedLocationIndex < startLocationIndex || selectedLocationIndex > this.props.settings.ListCount + startLocationIndex) {
          setTimeout(function () {
            _this2.setState({
              currentPage: Math.floor(selectedLocationIndex / _this2.props.settings.ListCount)
            });
          }, 0);
        }
      }

      var pageState = this.calculatePageState(this.state.currentPage, this.props.selectedLocation);

      var distance = function distance(toLocation) {
        return LocationSortingManager.getDistanceFromLatLngInKm(_this2.props.userLocation, toLocation).toFixed(2);
      };

      return /*#__PURE__*/React.createElement("div", {
        className: "locations-list ".concat(this.props.layoutType)
      }, /*#__PURE__*/React.createElement(Route, {
        path: "/location/:id",
        render: function render(props) {
          var dist = 0;
          var locationForId = truncatedLocations.find(function (loc) {
            return loc.UniqueId === props.match.params.id;
          });
          if (locationForId) dist = distance(locationForId);
          return /*#__PURE__*/React.createElement(DetailView, _extends({}, props, _this2.props, {
            distance: dist
          }));
        }
      }), this.props.filterListOpen && /*#__PURE__*/React.createElement(FilterList, this.props), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/",
        render: function render() {
          return /*#__PURE__*/React.createElement(React.Fragment, null, renderComponents('header', _this2.props.header, _this2.props), /*#__PURE__*/React.createElement("div", {
            className: "content"
          }, truncatedLocations.map(function (location, index) {
            var itemProps = Object.assign({
              key: "locationItem-".concat(location.UniqueId),
              location: location,
              index: index,
              distance: distance(location)
            }, _this2.props, {
              onSelectLocation: _this2.handleSelectLocationClick,
              onPhoneClick: _this2.handlePhoneClick
            });

            if (_this2.isNewlySelected && location.equals(_this2.props.selectedLocation)) {
              _this2.isNewlySelected = false;

              if (!_this2.isLocallySelected) {
                setTimeout(_this2.scrollSelectedIntoView, 0);
              }

              _this2.isLocallySelected = false;
            }

            return /*#__PURE__*/React.createElement(ItemView, itemProps);
          })), /*#__PURE__*/React.createElement(ListPager, _extends({
            previousPageClick: _this2.handlePreviousPageClick,
            nextPageClick: _this2.handleNextPageClick,
            currentStart: pageState.currentStartRecord,
            currentEnd: pageState.currentEndRecord,
            currentPage: _this2.state.currentPage,
            totalRecords: _this2.props.locations.length,
            disablePrev: pageState.disablePrevButton,
            disableNext: pageState.disableNextButton
          }, _this2.props)), renderComponents('footer', _this2.props.footer, _this2.props));
        }
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, theState) {
      if (nextProps.locationsStateHash !== theState.locationsStateHash) {
        var newState = INITIAL_PAGER_STATE;
        newState.locationsStateHash = nextProps.locationsStateHash;
        return newState;
      }

      return null;
    }
  }]);

  return ListPaginated;
}(React.Component);

export default ListPaginated;
ListPaginated.propTypes = {
  selectedLocation: defaultPropTypes.location,
  userLocation: defaultPropTypes.location,
  openLocation: defaultPropTypes.location,
  locations: defaultPropTypes.locations,
  onSelectLocation: defaultPropTypes.func,
  onOpenLocation: defaultPropTypes.func,
  onCloseLocation: defaultPropTypes.func,
  onCloseFilterList: defaultPropTypes.func,
  onChangeFilter: defaultPropTypes.func,
  layoutType: defaultPropTypes.layoutType,
  settings: defaultPropTypes.settings,
  header: PropTypes.arrayOf(PropTypes.element),
  footer: PropTypes.arrayOf(PropTypes.element),
  listItemView: PropTypes.func,
  listDetailView: PropTypes.func,
  filterListOpen: PropTypes.bool,
  locationDetailOpen: PropTypes.bool,
  locationsStateChanged: PropTypes.string,
  locationsStateHash: PropTypes.string
};
ListPaginated.defaultProps = {
  selectedLocation: defaultPropTypes.defaultLocation(),
  userLocation: defaultPropTypes.defaultLocation(),
  openLocation: defaultPropTypes.defaultLocation(),
  locations: defaultPropTypes.defaultLocations,
  onSelectLocation: defaultPropTypes.defaultOnSelectLocation,
  onOpenLocation: defaultPropTypes.defaultOnOpenLocation,
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation,
  onCloseFilterList: defaultPropTypes.defaultOnCloseFilterList,
  onChangeFilter: defaultPropTypes.defaultOnChangeFilter,
  layoutType: defaultPropTypes.defaultLayoutType,
  settings: defaultPropTypes.defaultSettings,
  header: [],
  footer: [],
  listItemView: ListItem,
  listDetailView: LocationDetail,
  filterListOpen: false,
  locationDetailOpen: false,
  locationsStateChanged: '',
  locationsStateHash: ''
};
ListPager.propTypes = {
  currentStart: PropTypes.number.isRequired,
  currentEnd: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  previousPageClick: PropTypes.func.isRequired,
  nextPageClick: PropTypes.func.isRequired,
  totalRecords: PropTypes.number.isRequired,
  disablePrev: PropTypes.string.isRequired,
  disableNext: PropTypes.string.isRequired
};